export const AVAILABLEDOCUMENTTYPES = [
	{ id: '305', name_en: 'Invoice', name_ar: 'فاتورة ضريبية', name_he: 'חשבונית מס' },
	{ id: '320', name_en: 'Invoice With Receipt', name_ar: 'فاتورة ضريبية / وصل', name_he: "חשבונית מס / קבלה" },
	{ id: '330', name_en: 'Reverse Invoice', name_ar: 'فاتورة عكسية', name_he: 'חשבונית זיכוי' },
	{ id: '332', name_en: 'Financial Request', name_ar: 'مطالبة', name_he: 'חשבונית עסקה' },
	{ id: '400', name_en: 'Receipt', name_ar: 'وصل', name_he: 'קבלה' },
	{ id: '100', name_en: 'Order', name_ar: 'طلبية', name_he: 'הזמנה' },
	{ id: '200', name_en: 'Devilry note', name_ar: 'ارسالية', name_he: 'תעודת משלוח' },
	{ id: '0', name_en: 'Price Offer', name_ar: 'عرض سعر', name_he: 'הצעת מחיר' },
	{ id: '430', name_en: 'Cancelled Receipt', name_ar: 'وصل عكسي', name_he: 'קבלה מבוטלת' },
];

export const AVAILABLEDOCUMENTLANGUAGES = [
	{ code: 'en', name: 'English' },
	{ code: 'he', name: 'Hebrew' },
	{ code: 'ar', name: 'Arabic' }
];

export const PAYMENTMETHODS = [
	{ id: 1, code: "CASH", name_en: "Cash", name_ar: "نقدي", name_he: "מזומן" },
	{ id: 2, code: "CHK", name_en: "Check", name_ar: "شيك", name_he: "שיק" },
	{ id: 0, code: "BT", name_en: "Bank Transfer", name_ar: "حوالة بنكية", name_he: "העברה בנקאית", },
	{ id: 3, code: "CC", name_en: "Credit Card", name_ar: "بطاقة ائتمان", name_he: "כרטיס אשראי" },
];